// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"task-marked"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M22.25 13.9961H15.75V21.5L19.0035 19.5L22.25 21.5V13.9961Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8 6V4H4V22H11.5M8 6H16M8 6V2H16V6M16 6V4H20V10","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M22.25 13.9961H15.75V21.5L19.0035 19.5L22.25 21.5V13.9961Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TaskMarkedIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'task-marked',
    ref,
    icon: element,
  },
));

TaskMarkedIcon.displayName = 'TaskMarkedIcon';

export default TaskMarkedIcon;
